import axios from '@/api'
import {API_URL_BASE} from "../../constants/config";

export default {
  fetchRoutes({ commit }, payload){
    return new Promise((resolve, reject) => {
      if(payload.page){
        commit('SET_CURRENT_PAGE', payload.page)
      }
      axios.get('/admin/routes/',{params: payload})
        .then((response) => {
          commit('SET_ROUTES', response.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  getRoutes({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.get('/admin/routes/',{params: payload})
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  MassLoadRoutes({ commit }, formData){
    return new Promise((resolve, reject) => {
      axios.post('/admin/routes/import/',formData,{headers: { 'Content-Type': 'multipart/form-data' } })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  }, 
  CheckRoutesProgress({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.get('/admin/routes/import/'+payload.task_id+'/progress/',{params: payload})
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  fetchRoutesReport({ commit },payload){ 
    return new Promise((resolve, reject) => {
      axios.get(`/admin/routes/`, {params:  payload , headers:{
        responseType: 'blob'
    }, responseType: 'blob' })
          .then((response) => {
            
            resolve(response.data)
          })
          .catch((error) => { reject(error) })
    })
  },
  storeRoute({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.post('/admin/routes/', payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  storeRouteshift({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.post('/admin/routes/'+payload.route_id+'/shift/', payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  updateRouteshift({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.put('/admin/routes/'+payload.route_id+'/shift/', payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  getRouteshift({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.get('/admin/routes/'+payload.route_id+'/shift/', payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  getRoute({ commit }, payload){
    return new Promise((resolve, reject) => {
      let url = '/admin/routes/'+payload.id+'/';
      delete payload.id;
      axios.get(url)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  updateRoute({ commit }, payload){
    return new Promise((resolve, reject) => {
      let url = '/admin/routes/'+payload.id+'/';
      delete payload.id;

      axios.put(url, payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  deleteRoute({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.delete('/admin/routes/'+payload.id+'/')
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  updateRouteStations({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.put('/admin/routes/'+payload.id+'/stations/',payload.stations)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  getStations({ commit }, payload){
    return new Promise((resolve, reject) => {
      if(payload.page){
        commit('SET_STATION_PAGE', payload.page)
      }
      axios.get('/admin/stations/', {params: payload})
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  storeStation({commit}, payload){
    return new Promise((resolve, reject) => {
      axios.post('/admin/stations/', payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  getStation({commit}, payload){
    return new Promise((resolve, reject) => {
      let url = `/admin/stations/${payload.id}/`;
      axios.get(url)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  updateStation({commit}, payload){
    return new Promise((resolve, reject) => {
      let url = `/admin/stations/${payload.id}/`;
      delete payload.id;
      axios.put(url, payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  deleteStation({commit}, payload){
    return new Promise((resolve, reject) => {
      axios.delete(`/admin/stations/${payload.id}/`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  routesService({commit}, payload){
    return new Promise((resolve, reject) => {

      let url = `https://fleet.ls.hereapi.com/2/calculateroute.json?apiKey=HexfLkPKpsc7LhtmttUoZAOTYh2zMWs5tzYfm8ggk3g&routeMatch=1&mode=fastest;car;traffic:disabled`

      for(let [index, item] of payload.waypoints.entries()){
        url+=`&waypoint${index}=${item.lat},${item.lng}${payload.sort && index>0 && index < (payload.waypoints.length -1)?';sort':''}`
      }

      fetch(url)
        .then(response=>{
          return response.json();
        })
        .then(data=>{
          resolve(data)
        })
        .catch(error =>{
          console.log(error);
        });

    })
  },


}
